// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://gnosisscan.io/address/0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73
export const GHO_TOKEN = '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73';

// https://gnosisscan.io/address/0xDe6539018B095353A40753Dc54C91C68c9487D4E
export const GHO_CCIP_TOKEN_POOL = '0xDe6539018B095353A40753Dc54C91C68c9487D4E';

// https://gnosisscan.io/address/0x360d8aa8F6b09B7BC57aF34db2Eb84dD87bf4d12
export const GHO_ORACLE = '0x360d8aa8F6b09B7BC57aF34db2Eb84dD87bf4d12';

// https://gnosisscan.io/address/0x6e637e1E48025E51315d50ab96d5b3be1971A715
export const GHO_AAVE_CORE_STEWARD = '0x6e637e1E48025E51315d50ab96d5b3be1971A715';

// https://gnosisscan.io/address/0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee
export const GHO_BUCKET_STEWARD = '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee';

// https://gnosisscan.io/address/0x06179f7C1be40863405f374E7f5F8806c728660A
export const GHO_CCIP_STEWARD = '0x06179f7C1be40863405f374E7f5F8806c728660A';

// https://gnosisscan.io/address/0x8513e6F37dBc52De87b166980Fa3F50639694B60
export const RISK_COUNCIL = '0x8513e6F37dBc52De87b166980Fa3F50639694B60';

export const CHAIN_ID = 100;
